import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
function normalizeIcon(icon) {
  if (!icon) return 'fas fa-circle';
  if (icon.includes(' ')) return icon;
  return `fas fa-${icon}`;
}
function extractItem(vnode) {
  if (!vnode || typeof vnode !== 'object') return null;
  const attrs = vnode.attrs;
  if (!attrs || typeof attrs !== 'object') return null;
  const children = Array.isArray(vnode.children) ? vnode.children : vnode.children != null ? [vnode.children] : [];
  return {
    icon: normalizeIcon(attrs.icon || ''),
    label: children.find(c => c != null && typeof c !== 'symbol') ?? null,
    href: attrs.href,
    onclick: typeof attrs.onclick === 'function' ? attrs.onclick : undefined,
    isPrimary: typeof attrs.className === 'string' && attrs.className.includes('Button--primary'),
    isDisabled: attrs.disabled === true,
    isActive: attrs.active === true
  };
}
function renderItem(data, key, prefix) {
  if (!data) return null;
  const {
    icon,
    label,
    href,
    onclick,
    isPrimary,
    isDisabled,
    isActive
  } = data;
  const cls = [prefix, isPrimary && `${prefix}--primary`, isActive && `${prefix}--active`, isDisabled && `${prefix}--disabled`].filter(Boolean).join(' ');
  const inner = m('[', null, m("span", {
    className: `${prefix}-icon`,
    "aria-hidden": "true"
  }, m("i", {
    className: `icon ${icon}`
  })), m("span", {
    className: `${prefix}-label`
  }, label));
  if (href) {
    return m("a", {
      key: key,
      className: cls,
      href: href,
      onclick: e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        m.route.set(href);
      }
    }, inner);
  }
  return m("button", {
    key: key,
    type: "button",
    className: cls,
    disabled: isDisabled,
    onclick: onclick
  }, inner);
}
class BentoSlider {
  track = null;
  canLeft = false;
  canRight = false;
  handleScroll = () => this.updateArrows();
  updateArrows() {
    if (!this.track) return;
    const {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = this.track;
    this.canLeft = scrollLeft > 1;
    this.canRight = scrollLeft + clientWidth < scrollWidth - 1;
    m.redraw();
  }
  oncreate({
    dom
  }) {
    this.track = dom.querySelector('.Bento-slider-track');
    if (this.track) {
      this.track.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
      this.updateArrows();
    }
  }
  onremove() {
    this.track?.removeEventListener('scroll', this.handleScroll);
    this.track = null;
  }
  scroll(dir) {
    if (!this.track) return;
    const {
      scrollLeft,
      clientWidth,
      scrollWidth
    } = this.track;
    const max = scrollWidth - clientWidth;
    const target = dir > 0 ? Math.min(scrollLeft + clientWidth, max) : Math.max(scrollLeft - clientWidth, 0);
    this.track.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  }
  view({
    attrs
  }) {
    const cls = ['Bento-slider', attrs.pillShape === 'rounded' && 'Bento-slider--rounded'].filter(Boolean).join(' ');
    return m("div", {
      className: cls
    }, this.canLeft && m("button", {
      type: "button",
      className: "Bento-slider-arrow Bento-slider-arrow--left",
      onclick: () => this.scroll(-1),
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-chevron-left"
    })), m("div", {
      className: "Bento-slider-track"
    }, attrs.items.map(({
      data,
      key
    }) => renderItem(data, key, 'Bento-pill'))), this.canRight && m("button", {
      type: "button",
      className: "Bento-slider-arrow Bento-slider-arrow--right",
      onclick: () => this.scroll(1),
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-chevron-right"
    })));
  }
}
app.initializers.add('forumaker-bento', () => {
  override(IndexSidebar.prototype, 'view', function (original) {
    if (!TagsPage || !app.current.matches(TagsPage)) return original();
    if (window.matchMedia?.('(max-width: 768px)')?.matches) return original();
    const cols = Number(app.forum.attribute('forumaker-bento.columns_desktop') || 4);
    const layout = app.forum.attribute('forumaker-bento.layout') || 'tiles';
    const pillShape = app.forum.attribute('forumaker-bento.pill_shape') || 'capsule';
    const plainCreate = app.forum.attribute('forumaker-bento.plain_create_button');
    const newDiscData = extractItem(this.items().get('newDiscussion'));
    if (newDiscData && plainCreate) newDiscData.isPrimary = false;
    const allItems = [];
    if (newDiscData) allItems.push({
      data: newDiscData,
      key: 'newDiscussion'
    });
    for (const [i, vnode] of this.navItems().toArray().entries()) {
      const d = extractItem(vnode);
      if (d) allItems.push({
        data: d,
        key: `nav-${i}`
      });
    }
    const navClass = 'IndexPage-sidebar Bento-sidebar';
    if (layout === 'slider') {
      return m("nav", {
        className: navClass
      }, m(BentoSlider, {
        items: allItems,
        pillShape
      }));
    }
    if (layout === 'pills') {
      const containerClass = ['Bento-pills', pillShape === 'rounded' && 'Bento-pills--rounded'].filter(Boolean).join(' ');
      return m("nav", {
        className: navClass,
        style: {
          '--bento-cols': String(cols)
        }
      }, m("div", {
        className: containerClass
      }, allItems.map(({
        data,
        key
      }) => renderItem(data, key, 'Bento-pill'))));
    }
    return m("nav", {
      className: navClass,
      style: {
        '--bento-cols': String(cols)
      }
    }, m("div", {
      className: "Bento-grid"
    }, allItems.map(({
      data,
      key
    }) => renderItem(data, key, 'Bento-tile'))));
  });
});